import { cn } from "ui";

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {}

export function Heading({ className, ...props }: HeadingProps) {
  return (
    <h2
      className={cn("text-lg font-bold text-foundations-boldest", className)}
      {...props}
    />
  );
}
